export class PlannerBusinessScenario {
  bsEnabled?: boolean;

  bsId?: string;

  bsGroupId?: string;

  bsPlanId?: string;

  bsDisplayName?: string;

  bsUniqueName?: string;

  toJSON(): string {
    const pBs = {
      bsEnabled: this.bsEnabled,
      bsId: this.bsId,
      bsGroupId: this.bsGroupId,
      bsPlanId: this.bsPlanId,
      bsDisplayName: this.bsDisplayName,
      bsUniqueName: this.bsUniqueName,
    };

    return JSON.stringify(pBs);
  }

  fromJSON(data: string | undefined): void {
    try {
      if (data) {
        const newData = JSON.parse(data);
        this.bsEnabled = newData.bsEnabled;
        this.bsId = newData.bsId;
        this.bsGroupId = newData.bsGroupId;
        this.bsPlanId = newData.bsPlanId;
        this.bsDisplayName = newData.bsDisplayName;
        this.bsUniqueName = newData.bsUniqueName;
      }
    } catch {
      //ignore
    }
  }
}
